import React from 'react'
import classNames from 'classnames'
import format from 'date-fns/format';

import Week from '../Week';

export default function Month({
    selectedDates,
    onSelect,
    onChange,
    schedule,
    hasSchedule,
    date
}) {

    const { month, weeks } = date;

    const MonthClasses = classNames({
        "ola-month": true,
        "mb-4": !hasSchedule,
        "border border-gray border-b-0 last:border-b": hasSchedule
    })

    const MonthTextClasses = classNames({
        "text-lg text-center font-semibold py-2 bg-extralightprimary": true,
        "bg-white border-t border-line pt-4": !hasSchedule
    })

    return (
        <div className={MonthClasses}>
            <div className={MonthTextClasses}>{format(month, 'MMMM yyyy')}</div>
            
            <div className="ola-weeks">

                {weeks?.map(({days}, index) => {
                    return (
                        <Week
                            key={index}
                            index={index}
                            selectedDates={selectedDates}
                            onSelect={onSelect}
                            onChange={onChange}
                            schedule={schedule}
                            month={month}
                            days={days}
                            weeksLength={weeks?.length}
                            hasSchedule={hasSchedule}
                        />
                    )
                })}
            </div>
        </div>
    )
}
